<template>
   <div class="wrap" :class="{'wrap-row':layout=='row'}">
      <div class="order" v-if="orderInfo.count>0">
         <div class="toBePaid" :class="{'multiple': orderInfo.count>1}">
            <dl>
               <dt>
                  <svg-icon data_iconName="clock" className="clock"></svg-icon>
                  <!-- <img src="@/assets/images/buy/clock-icon.png" alt=""> -->
               </dt>
               <dd>
                  <p v-if="orderInfo.count>1" @click="goOrder">您有{{orderInfo.count}}笔待支付订单<i class="el-icon-arrow-right"></i></p>
                  <p v-else>待支付订单</p>
                  <div class="countdown">
                     <template v-if="orderInfo.count>1">订单1：{{orderInfo.order.id | replaceStr(3,9,'****')}}将在 <CountDown :format="1" :endTime="orderInfo.order.paymentExpiredAt" :currentTime="currentTime" :id="0" @over="activityOver" @countNum="countNum" /> 后关闭</template>
                     <template v-else><CountDown :format="1" :endTime="orderInfo.order.paymentExpiredAt" :currentTime="currentTime" :id="0" @over="activityOver" @countNum="countNum" />后支付关闭</template>
                  </div>
               </dd>
            </dl>
            <ul>
               <li>订单号：{{orderInfo.order.id | replaceStr(3,9,'****')}}</li>
               <li>时间戳个数：{{orderInfo.order.tsCount}}个</li>
               <li>待支付金额：<b>¥{{ orderInfo.order.payAmount }}</b></li>
            </ul>
            <div class="btns">
               <span @click="cancelOrder">取消订单</span>
               <span @click="goPayOredr">继续支付</span>
            </div>
         </div>
      </div>
      <div class="content">
         <div class="package-container">
            <div class="instructions">
               <p>
                  <span>请选择一个套餐：<b>（单价：10元/时间戳）</b>请按需购买，注意服务有效期，开始使用后无法退款！使用不同产品服务消耗时间戳数及标准请参考<a href="/userAccount/buy/rules" target="_blank" @click="goBilling">计费规则</a></span>
               </p>
               <p @click="goCalculator">
                  <svg-icon data_iconName="jsq" className="calculator-icon"></svg-icon>
                  <span>取证费用算一算</span>
                  <i class="el-icon-arrow-right"></i>
               </p>
            </div>
            <div class="package">
               <div class="package-type-list">
                  <template v-for="item in packageTypeList">
                     <div class="package-type" v-if="item.suiteType===0 && item.suites" :key="'id'+item.id">
                        <div class="package-type-title">
                           <div class="title">
                              {{ item.title }}
                              <div class="rules" v-if="discountShow">
                                 <!-- <img src="@/assets/images/buy/tishi-icon.png" alt=""> -->
                                 <svg-icon data_iconName="info" className="info"></svg-icon>
                                 <div class="popover" :class="{'popoverShow': rulesTableShow}">
                                    <div class="popover-content">
                                       <div class="table">
                                          <dl>
                                             <dt>自定义购买时间戳个数</dt>
                                             <dd>优惠金额</dd>
                                          </dl>
                                          <dl v-for="(item,index) in rules" :key="index">
                                             <dt v-if="(rules.length-1)==index">{{item.range[0]}}个及以上</dt>
                                             <dt v-else>{{item.range[0]}}至{{item.range[1]-1}}个</dt>
                                             <dd>优惠{{item.discount}}元</dd>
                                          </dl>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="periodDay">
                              *使用期限{{item.validityPeriod}}天
                           </div>
                        </div>
                        <div class="inputNumber">
                           <span>购买数量：</span>
                           <MyInputNumber v-model="num" @on-change="changeNum" @input="changeNum" @focus="rulesTableShow=true" @blur="rulesTableShow=false" />
                           <div class="popover" v-if="num && rulesDiscount">
                              <div class="popover-content">
                                 <div class="amount">
                                    <img src="@/assets/images/buy/youhui-icon.png" alt="">
                                    <span>优惠{{rulesDiscount}}元</span>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <component 
                        :is="item.suiteType==2?'section':'div'" 
                        class="package-type" 
                        :class="'package-type-'+item.suiteType" 
                        :key="item.id"
                        v-else-if="item.suites"
                     >
                        <div class="package-type-title">
                           <div class="title">
                              {{ item.title }}
                              <div class="rules" v-if="item.suiteType==3">
                                 <svg-icon data_iconName="info" className="info"></svg-icon>
                                 <div class="popover">
                                    <div class="popover-content">
                                       <div class="newSuitRules">
                                          <h3>新用户专享套餐须知</h3>
                                          <p>1.仅限未充值过的新用户</p>
                                          <p>2.专享套餐只能任选其一</p>
                                          <p>3.专享套餐仅限购买一次</p>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="period" v-if="item.activityEndAt && (item.suiteType==2 || item.suiteType==3)">
                              距离活动结束还剩<CountDown :endTime="item.activityEndAt" :currentTime="currentTime" :id="item.id" @over="activityOver" @countNum="countNum" />
                           </div>
                           <div class="periodDay" v-if="item.suiteType==1">
                              *使用期限{{item.validityPeriod}}天
                           </div>
                        </div>
                        <ul>
                           <li :class="pItem.id == chooseId? 'active': ''" v-for="pItem in item.suites" :key="pItem.id" @click="choose(pItem,item.title,item.suiteType,item.id)">
                              <div class="leaf" v-if="pItem.presentedTsCount>0">
                                 <p>送{{pItem.presentedTsCount}}个</p>
                              </div>
                              <div class="package-item-content">
                                 <div class="number">
                                    <div class="total">共 <b>{{pItem.tsCount+pItem.presentedTsCount}}</b> 个</div>
                                    <div class="period" v-if="item.suiteType!==1">使用期限{{pItem.validityPeriod==0?'永久': pItem.validityPeriod +'天'}}</div>
                                 </div>
                                 <div class="amount">
                                    <div class="consume">
                                       <b>¥{{ pItem.payAmount }}</b>
                                       <span v-if="pItem.payAmount!==pItem.amount">¥{{ pItem.amount }}</span>
                                    </div>
                                    <p v-if="pItem.payAmount!==pItem.amount">立省 ¥ {{pItem.amount-pItem.payAmount}}元</p>
                                 </div>
                              </div>
                           </li>
                        </ul>
                     </component>
                  </template>
               </div>
            </div>
            <div ref="packageContainerBottom"></div>
         </div>
         <div class="pay-container">
            <div class="card-title">
               <h3>付款明细</h3>
               <p class="large">购10万以上享优惠，扫码<b @click="contractOur">咨询客服</b></p>
            </div>
            <div class="pay-info">
               <dl>
                  <dt>购买个数：</dt>
                  <dd class="number">
                     <b>{{ timeStamp ? timeStamp+'个' : '-' }}</b>
                     <p v-if="discount && totalPrice<=maxPaymentAmount">套餐内含{{timeStamp}}个时间戳 享<strong class="red">{{decimalToDiscountChinese}}优惠权益</strong>额外送{{complimentary}}个时间戳，共<strong class="blue">{{timeStamp+complimentary}}</strong>个时间戳</p>
                  </dd>
               </dl>
               <dl>
                  <dt>优惠：</dt>
                  <dd class="coupon">
                     <div class="no" @click="openCoupon" v-if="!num && (!chooseId && chooseId!==0)">
                        <span>-</span>
                     </div>
                     <div class="couponType noCoupon" @click="openCoupon" v-else-if="!availableCouponOne.name">
                        <span>暂无可用优惠券</span>
                        <div class="arrow-icon">
                           <i class="el-icon-arrow-right"></i>
                        </div>
                     </div>
                     <div class="couponType currentCoupon" @click="openCoupon" v-else-if="JSON.stringify(currentCoupon)!=='{}'">
                        <div class="info">
                           <img src="@/assets/images/buy/coupon-icon.png" alt="">
                           <span>{{currentCoupon.name}}</span>
                           <b>-¥{{currentCoupon.discountAmount}}</b>
                        </div>
                        <div class="arrow-icon">
                           <i class="el-icon-arrow-right"></i>
                        </div>
                     </div>
                     <div class="couponType hasCoupon" @click="openCoupon" v-else>
                        <span>{{couponData.availableCoupon.length}}张可用优惠券，最高减免{{availableCouponOne.discountAmount}}元</span>
                        <div class="arrow-icon" >
                           <i class="el-icon-arrow-right"></i>
                        </div>
                     </div>
                     
                  </dd>
               </dl>
               <dl class="pay-type-wrap">
                  <dt><b>*</b>付费方式：</dt>
                  <dd class="pay-type" :class="{'pay-type-disabled':!(chooseId || num)}">
                     <MyRadioGroup v-model="payType" @change="choosePay" :disabled="!(chooseId || num)">
                        <MyRadio v-for="item in payTypeList" :key="item.value" :label="item.value">
                           <div class="label">
                              <svg-icon :data_iconName="item.icon" :className="item.icon"></svg-icon>
                              {{item.title}}
                           </div>
                        </MyRadio>
                     </MyRadioGroup>
                     <p class="large">购10万以上享优惠，扫码<b @click="contractOur">咨询客服</b></p>
                  </dd>
               </dl>
               <dl class="amount">
                  <dt>实付金额：</dt>
                  <dd class="amount">
                     <b>{{finalPrice? '¥'+finalPrice : '-'}}</b>
                     <span v-if="originalPrice && (finalPrice!==originalPrice)">¥{{ originalPrice }}</span>
                  </dd>
               </dl>
            </div>
            <div class="pay-start">
               <div class="read">
                  <el-checkbox v-model="checked" @change="handleCheckboxChange">
                     <span>
                        我已阅读并同意<a :href="agrementUrl" target="_blank" style="color:#6288FB" @click="goDoc">《电子证据服务订购协议》</a><a href="/userAccount/buy/refundPolicy" target="_blank" style="color:#6288FB">《退费规则》</a>
                     </span>
                  </el-checkbox>
               </div>
               <div class="pay-btn">
                  <span @click="goBuy" :disabled="((chooseId || num))? false:true">去支付</span>
               </div>
            </div>
         </div>
      </div>
      <el-dialog
         title="咨询客服"
         :visible.sync="customerService"
         width="500px"
         top="27vh"
         class="mydia"
         center
      >
         <img class="customerService" src="https://tsa-content.oss-cn-beijing.aliyuncs.com/customerService/pay-suite.jpg" />
      </el-dialog>
      <el-dialog
         title="银行卡转账(对公付款）"
         :visible.sync="unionPayDia"
         width="850px"
         top="27vh"
         class="mydia"
         center
         :before-close="closeUnionPay"
      >
         <div class="unionPay">
            <div class="unionPayInfo">
               <div class="info">
                  <p><b> 注：</b>支持通过银行汇款充值，联合信任将在收到汇款后，人工方式为您充值。</p>
                  <div class="info-cnt">
                     <div class="accountInfo">
                        <dl>
                           <dt>户名：</dt>
                           <dd>北京联合信任技术服务有限公司</dd>
                        </dl>
                        <dl>
                           <dt>行号：</dt>
                           <dd>959</dd>
                        </dl>
                        <dl>
                           <dt>开户行：</dt>
                           <dd>兴业银行北京西客站支行</dd>
                        </dl>
                        <dl>
                           <dt>账号：</dt>
                           <dd>3211 0010 0100 0337 04</dd>
                        </dl>
                     </div>
                     <div class="copyBtn">
                        <span v-clipboard:copy="copyValue" v-clipboard:success="copySuccess" v-clipboard:error="copyError">复制账户信息</span>
                     </div>
                  </div>
               </div>
               <div class="qrcode">
                  <div class="wechatQrcode"></div>
                  <p>使用微信扫描二维码添加企业微信</p>
               </div>
            </div>
            <div class="note">
               <i class="el-icon-info"></i>
               <p>*请注意如下事项：</p>
               <ul>
                  <li>办理银行转账时，请您务必在汇款单的用途栏内注明您的用户名。</li>
                  <li>汇款后请将汇款凭证及您的信息（姓名、电话、用户名）扫描通过企业微信发送给我们，以便我们核实您的款项。</li>
                  <li>核实汇款后，我们将在5个工作日内为您的账户进行充值。</li>
               </ul>
            </div>
         </div>
      </el-dialog>
      <el-dialog
            class="couponDia"
            title="我的优惠券"
            :visible.sync="chooseCouponDia"
            width="800px"
            :modal-append-to-body="false"
            center
      >
         <ChooseCoupon :couponData="couponData" :currentCoupon="currentCoupon" @chooseCurrentCoupon="chooseCurrentCoupon" />
      </el-dialog>
   </div>
</template>

<script>
import MyInputNumber from '@/components/basics/InputNumber/index.vue';
import MyRadioGroup from "@/components/basics/Radio/radio-group";
import MyRadio from "@/components/basics/Radio/radio";
import ChooseCoupon from '@/components/UserAccount/ChooseCoupon';
import CountDown from "@/components/basics/CountDown/index";
import { getSuite,getPendingPaymentOrder} from "@http/overview/buy";
import { getOrderId,nativeBuy,getAvailableCoupon } from "@http/overview/index";
import {orderToCancel} from "@http/order/index";
import {debounce,findRangeByValue,removeURLParameter} from "@/utils/utils";
import { sourceType } from "@/utils/filter.js";
var timerId=null;
export default {
   data () {
      return {
         layout:'column',
         orderInfo:{},
         copyValue:'户名：北京联合信任技术服务有限公司\r\n行号：959\r\n开户行：兴业银行北京西客站支行\r\n账号：3211 0010 0100 0337 04',
         num:'',
         rules:[],//单个购买的规则
         rulesTableShow:false,//提示规则是否显示
         rulesDiscount:'',//自定义套餐优惠金额
         payArray:['WECHAT_PAY','ALI_PAY','BANK','NOT_PAY'],
         payType:0,
         payTypeList:[
            {
               title:'微信支付',
               icon:'wx',
               value:0,
            },
            {
               title:'支付宝',
               icon:'zfb',
               value:1,
            },
            {
               title:'银行汇款',
               icon:'yl',
               value:2,
            },
         ],
         currentTime:new Date().getTime(),//当前时间定时器
         diffCurrentTime:'',//本地时间和服务器时间差
         startIds:[],//开始倒计时的活动套餐id集合
         checked:false,//阅读协议
         agrementUrl:process.env.VUE_APP_USERCENTERUI+'/agreement/serviceOrder',
         packageTypeList:[],//套餐类型集合（包含自定义套餐）
         singlePackage:{},//自定义套餐
         chooseId: "",
         dealItem:{},//包信息
         suiteItem:{},//套餐信息
         totalPrice:0,
         originalPrice:0,
         customerService:false,//客服二维码弹窗
         unionPayDia:false,//银联付款
         discount:'',//律协套餐折扣率
         timeStamp:0,//套餐总数
         tsCount:0,//套餐个数
         presentedTsCount:0,//套餐赠送个数
         maxPaymentAmount:'',//活动最大支付金额
         //   优惠券
         chooseCouponDia: false,
         couponInfoShow:false,
         couponData:{},//选中套餐对应的优惠券
         currentCoupon:{},//当前选择的优惠券
         couponList:[],//优惠券列表
         couponId:'',//优惠券id
      }
   },
   components: {MyInputNumber,MyRadioGroup,MyRadio,ChooseCoupon,CountDown},
   created () {
      this.getOrderInfo()
   },
   watch: {},
   computed: {
      discountShow(){
         if(this.rules.length>0){
            let discountItem=this.rules.find(item => item.discount !== 0);
            return discountItem ? true : false
         }else{
            return false
         }
      },
      channelCodeValue(){
         return this.$store.state.config.channelCodeValue;
      },
      //计算律协活动的赠送数量
      complimentary(){
         // （1/折扣率 -1）*不包含赠送的总数
         if(this.num){
               return (Math.round((1/this.discount -1)*this.tsCount*this.num))
         }else{
               return (Math.round((1/this.discount -1)*this.tsCount))
         }
      },
      //根据返回的折扣率转换成中文
      decimalToDiscountChinese() {
         let decimal=this.discount;
         if (isNaN(decimal) || decimal < 0 || decimal > 1) {
            return "0";
         }
         const nums = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
         const discount = Math.round(decimal * 100);

         if (discount % 10 === 0) {
            // 处理整十折扣，例如 0.8 -> 八折
            return nums[discount / 10] + "折";
         } else {
            // 处理非整十折扣，例如 0.95 -> 九五折
            const tens = Math.floor(discount / 10);
            const ones = discount % 10;
            return nums[tens] + nums[ones] + "折";
         }
      },
      //套餐对应可用优惠券第一个
      availableCouponOne(){
         if(this.couponData.availableCoupon && this.couponData.availableCoupon.length>0){
            return this.couponData.availableCoupon[0]
         }else if(this.couponData.availableCoupon && this.couponData.availableCoupon.length==0){
            return {availableCoupon:[]}
         }else{
            return {}
         }
      },
      //算上优惠券后总价
      finalPrice(){
         if(this.currentCoupon.discountAmount){
            return (this.totalPrice*100 - parseFloat(this.currentCoupon.discountAmount*100).toFixed(2))/100;
         }else{
            return this.totalPrice
         }
      }
   },
   mounted () {
      this.couponId = window.sessionStorage.getItem('couponId');
      let sourceTypeNum=parseInt(this.$getlocalStorage("queryData")?.sourceType || this.$getlocalStorage("queryData")?.clientId || 975260);
      let sourceTypeName=sourceType(sourceTypeNum) ? sourceType(sourceTypeNum) : sourceTypeNum
      zhuge.track('用户中心_进入立即购买',{'sourceType':sourceTypeName});
   },
   beforeDestroy() {
      window.sessionStorage.removeItem('couponId')
      if (timerId) {
         clearInterval(timerId)
         timerId = null
      }
   },
   methods: {
      async getOrderInfo(){
         try {
            let res= await getPendingPaymentOrder();
            this.orderInfo=res;
            this.init();
         } catch (error) {
            console.log(error)
         }
      },
      goOrder(){
         zhuge.track('用户中心_立即购买_待支付订单_标题',()=>{
            this.$router.push({
               path:'/order/orderList',
               query:{
                  tabVal:2
               }
            })
         });
      },
      goPayOredr(){
         let sourceTypeRaw=this.$getlocalStorage("queryData")?.sourceType || this.$getlocalStorage("queryData")?.clientId || 975260;
         let sourceType = /^[0-9]{6}$/.test(sourceTypeRaw) ? sourceTypeRaw : 975260;
         let orderId=this.orderInfo.order.id;
         zhuge.track('用户中心_待支付订单_继续支付',{
            '付费方式':['','支付宝','微信支付','银行汇款'][this.orderInfo.order.payType],
            '套餐名称':this.orderInfo.order.suiteConfigTitle || '',
            '服务包名称':this.orderInfo.order.suiteName,
            '时间戳个数':this.orderInfo.order.tsCount,
            '服务包金额':this.orderInfo.order.dueAmount,
            '页面名称':'立即购买'
         },()=>{
            window.location.href=`/api/order/continuePay?orderId=${orderId}&sourceType=${sourceType}`
         }); 
      },
      cancelOrder(){
         let that=this;
         let orderId=this.orderInfo.order.id;
         this.$confirm('确认取消该订单吗?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '关闭',
               type: 'warning'
         }).then(() => {
               orderToCancel({orderId}).then(async (res)=>{
                  zhuge.track('用户中心_待支付订单-取消订单',{'页面名称':'立即购买'});
                  that.getOrderInfo();
                  that.$TsaOrderCancelSuccessDialog.show({
                     type: 1,
                     traceMap: {
                        page: "立即购买"
                     }
                  })
               }).catch(() => {
                  that.$msg("该订单取消失败，请稍后再试");
               });
         })
      },
      async init(){
         timerId && clearInterval(timerId)
         timerId = null
         try {
            let res = await getSuite();
            let {suiteConfigs,serverDateTime,rules} =res;
            this.rules=rules;
            this.packageTypeList=suiteConfigs;
            this.singlePackage=suiteConfigs.find(item => item.suiteType === 0);
            // 如果存在套餐id 自动匹配套餐
            this.autoChoose()
            //倒计时
            this.$nextTick(()=>{
               // 元素距离可视区域顶部的高度,超过高度，改变页面结构
               const element = this.$refs.packageContainerBottom;
               const distanceToTop = element.getBoundingClientRect().top;
               if(distanceToTop>620){
                  this.layout='row'
               }else{
                  this.layout='column'
               }
               //有定时器组件被初始化了开始执行定时器
               if(this.startIds.length>0){
                  this.currentTime = serverDateTime;
                  this.diffCurrentTime=new Date().getTime()-serverDateTime;//本地时间和服务器时间的时间差
                  // 启动倒计时
                  timerId = setInterval(() => {
                     // 如果检测到当前时间和前一秒相差超过10S，代表用户修改本地时间，需要重新计算时间差
                     if(((new Date().getTime()-this.diffCurrentTime-this.currentTime ) > 10000) || ((new Date().getTime()-this.diffCurrentTime-this.currentTime ) < -10000)){
                        timerId && clearInterval(timerId)
                        timerId = null
                        this.init();
                     }else{
                        this.currentTime = new Date().getTime()-this.diffCurrentTime;
                     }
                  }, 1000)
               }
            })
         } catch (error) {
            console.log(error)
         }
      },
      async autoChoose () {
         let suiteId=this.chooseId || this.$route.query.suiteId;
         if(suiteId){
            //console.log(Object.prototype.toString.call(this.packageTypeList))
            if (Object.prototype.toString.call(this.packageTypeList) === "[object Array]") {
               outloop:for (let key = 0; key < this.packageTypeList.length;key++) {
                  for (let i = 0; i < this.packageTypeList[key].suites.length; i++) {
                     if (this.packageTypeList[key].suites[i].id == suiteId) {
                        if (this.packageTypeList[key].suiteType === 0) {
                           this.num=this.$route.query.buyCount
                           this.changeNum()
                        } else {
                           this.chooseFun(this.packageTypeList[key].suites[i])
                        }
                        break outloop;
                     }
                     if(key==this.packageTypeList.length-1 && i==this.packageTypeList[key].suites.length-1){
                        //最后一个包仍然没有匹配参数的id，去掉参数刷新页面
                        if (this.packageTypeList[key].suites[i].id !== suiteId){
                           window.location.href=removeURLParameter(window.location.href,'suiteId')
                        }
                     }
                  }
               }
            }
         }else{
            // 初始化套餐
            this.dealItem={};
            this.chooseId = '';
            this.totalPrice=0;
            this.originalPrice=0;
            this.timeStamp=0;
            this.tsCount=0;
            this.presentedTsCount=0;
            this.currentCoupon={};
            this.couponData={};
         }
      },
      goCalculator(){
         window.open(process.env.VUE_APP_USERCENTERUI+'/calculator/index?redirectUrl='+encodeURIComponent(window.location.href))
         zhuge.track('用户中心_立即购买_取证计算器');
      },
      formatNum (num) {
         return num < 10 ? '0' + num : '' + num
      },
      async chooseFun (item) {
         this.dealItem=item;
         this.chooseId = item.id;
         this.totalPrice=item.payAmount;
         this.originalPrice=item.amount;
         this.timeStamp=(item.tsCount+item.presentedTsCount);
         this.tsCount=item.tsCount;
         this.presentedTsCount=item.presentedTsCount;
         this.couponInfoShow=true;
         this.currentCoupon={};
         this.couponData={};
         try {
            let res= await getAvailableCoupon({suiteId:this.chooseId,buyCount:1,singleComputeStatus:1})
            if (res.availableCoupon && res.availableCoupon.length > 0 && Object.prototype.toString.call(res.availableCoupon) === "[object Array]") {
               if (this.couponId !== -1) {
                  if (this.couponId) {
                     for (let i = 0; i < res.availableCoupon.length; i++) {
                        let obj = res.availableCoupon[i];
                        if (obj.id == this.couponId) {
                           this.currentCoupon = obj
                           break
                        }
                     }
                  } else {
                     this.currentCoupon = res.availableCoupon[0]
                  }
               }
            }
            this.couponData=res
         } catch (error) {
            console.log(error)
         }
      },
      async choose(item,title,suiteType,suiteId) {
         this.num='';
         this.rulesDiscount='';
         this.suiteItem={};
         if(item.id==this.chooseId){
            this.dealItem={};
            this.chooseId = '';
            this.totalPrice=0;
            this.originalPrice=0;
            this.timeStamp=0;
            this.tsCount=0;
            this.presentedTsCount=0;
            this.couponInfoShow=false;
            this.currentCoupon={};
            this.couponData={};
         }else{
            this.suiteItem={
               suiteTitle:title,
               suiteType,
               id:suiteId
            }
            zhuge.track('用户中心_立即购买_套餐名称', {
               '套餐名称':title,
               '服务包名称':item.name,
               '套餐id':item.id
            })
            this.chooseFun(item)
         }
      },
      changeNum:debounce(async function(){
         this.suiteItem={
            id:this.singlePackage.id,
            suiteTitle:this.singlePackage.title,
            suiteType:0,
         }
         // 初始化套餐
         this.dealItem={};
         this.chooseId = '';
         this.totalPrice=0;
         this.originalPrice=0;
         this.timeStamp=0;
         this.tsCount=0;
         this.presentedTsCount=0;
         this.couponData={};
         this.currentCoupon={};
         if(this.num){
            let { discount }=findRangeByValue(this.rules, this.num)
            this.rulesDiscount=discount;
            let suitesItem=this.singlePackage.suites[0];
            this.totalPrice=suitesItem.payAmount*this.num-discount;
            this.originalPrice=suitesItem.amount*this.num;
            this.timeStamp=((suitesItem.tsCount)+(suitesItem.presentedTsCount))*(this.num);
            this.tsCount=suitesItem.tsCount;
            this.presentedTsCount=suitesItem.presentedTsCount;
            this.couponInfoShow=true;
            this.currentCoupon={};
            try {
               let res=await getAvailableCoupon({suiteId:suitesItem.id,buyCount:(this.num),singleComputeStatus:1})
               if (res.availableCoupon && res.availableCoupon.length > 0 && Object.prototype.toString.call(res.availableCoupon) === "[object Array]") {
                  if (this.couponId !== -1) {
                     if (this.couponId) {
                        for (let i = 0; i < res.availableCoupon.length; i++) {
                           let obj = res.availableCoupon[i];
                           if (obj.id == this.couponId) {
                                 this.currentCoupon = obj
                                 break
                           }
                        }
                     } else {
                        this.currentCoupon = res.availableCoupon[0]
                     }
                  }
               }
               this.couponData=res
            } catch (error) {
               console.log(error)
            }
         }else{
               this.couponInfoShow=false;
               this.totalPrice=0;
               this.originalPrice=0;
               this.timeStamp=0;
               this.tsCount=0;
               this.presentedTsCount=0;
         }
      }, 500),
      choosePay(){
         zhuge.track('用户中心_立即购买_付费方式',{
            '付费方式名称':this.payTypeList[this.payType]
         });
         if(this.payType==2){
            this.unionPayDia=true;
         }
      },
      chooseCurrentCoupon(item){
         this.currentCoupon=item;
         this.chooseCouponDia=false;
         this.couponId = item.id || -1;
         window.sessionStorage.setItem('couponId',this.couponId)
      },
      openCoupon(){
         if(this.chooseId || this.chooseId===0 || this.num){
            zhuge.track('用户中心_选择优惠券')
            this.chooseCouponDia = true
         }
         return
      },
      handleCheckboxChange(){
         if(this.checked){
            this.$TsaWebTrace.post({
               data: {
                  "eventId": 300041,
               },
            });
         }else{
            this.$TsaWebTrace.post({
               data: {
                  "eventId": 300042,
               },
            });
         }
      },
      contractOur(){
         this.customerService=true;
      },
      closeUnionPay(){
         this.unionPayDia=false;
         this.payType=0;
      },
      copySuccess(e) {
         this.$message({
            type: 'success',
            message: '账户信息已复制'
         });
      },
      copyError(e) {
         this.$message({
            type: 'error',
            message: '系统复制失败，请进行手动复制'
         });
      },
      //记录已完成的定时器
      activityOver(id){
         let index = this.startIds.indexOf(id);
         if (index !== -1) {
            this.startIds.splice(index, 1);
         }
         if(id===0){//待支付订单到期
            this.getOrderInfo();
            return
         }
         this.init()
      },
      //记录已开始的定时器
      countNum(id){
         this.startIds=[...this.startIds,id]
      },
      async locationPay(){
         let suiteId;
         if(this.chooseId){
            suiteId=this.chooseId
         }else if(this.num){
            suiteId=this.singlePackage.suites[0].id
         }else{
            this.$msg("请选择要购买的套餐");
         }
         let sourceTypeRaw=this.$getlocalStorage("queryData")?.sourceType || this.$getlocalStorage("queryData")?.clientId || 975260
         let sourceType = /^[0-9]{6}$/.test(sourceTypeRaw) ? sourceTypeRaw : 975260
         let partnerType=this.$getlocalStorage("queryData")?.partnerType || 0
         if(this.$route.query.callBackUrl){
               this.$setlocalStorage('callBackUrl',this.$route.query.callBackUrl)
         }
         if(this.payType==1){
               let newTab=window.open('about:blank');
               let res = await getOrderId();
               newTab.location.href=`/api/order/buy?orderId=${res.id}&suiteId=${suiteId}&buyCount=${this.num?this.num:1}&payType=${this.payArray[this.payType]}&sourceType=${sourceType}&partnerType=${partnerType}${this.currentCoupon.id?'&userCouponId='+this.currentCoupon.id:''}`
               this.$alert('已为您打开了新的窗口，继续使用该窗口需进行刷新操作', '提示', {
                  confirmButtonText: '刷新',
               }).then(()=>{
                  location.reload()
               }).catch(()=>{
                  location.reload()
               });
         }else{
               try {
                  let res = await getOrderId();
                  let buyCount = this.num?this.num:1
                  let res2= await nativeBuy({
                     orderId:res.id,
                     suiteId:suiteId,
                     buyCount,
                     payType:this.payArray[this.payType],
                     sourceType,
                     partnerType,
                     userCouponId:this.currentCoupon.id
                  });
                  this.$router.push({
                     path:'/userAccount/wxPay',
                     query:{...res2,codeUrl:res2.codeUrl,suiteId:suiteId, buyCount},
                  })
               } catch (error) {
                  console.log(error)
               }
         }
      },
      goBuy(){
         zhuge.track('用户中心_去支付', {
            '用户行为':'充值',
            '使用优惠券':this.currentCoupon.id ? '是' : '否'
         })
         zhuge.track('用户中心_立即购买_去支付',{
            '付费方式':this.payTypeList[this.payType],
            '套餐名称':this.suiteItem.suiteTitle,
            '服务包名称':this.dealItem.name,
            '时间戳个数':this.timeStamp,
            '服务包金额':this.totalPrice
         });
         if(!this.checked){
            this.$msg("请先阅读并勾选协议");
            return
         }

         if(!this.chooseId && !this.num){
            this.$msg("请选择要购买的套餐");
            return false;
         }
         if(this.payType==2){
            this.$msg("您选择银行汇款的方式，请按照汇款信息进行银行汇款。",'warning');
            return false;
         }

         this.locationPay();

      },
      goBilling(){
         zhuge.track('用户中心_立即购买_计费规则')
      },
      goDoc(){
         zhuge.track('用户中心_立即购买_电子证据协议')
      }
   }
}
</script>

<style src="@/assets/css/buy.less" lang='less' scoped></style>
